import React from "react";
import OrderDetails from "../../components/OrderDetails/OrderDetails";
import { useOrderDetailsPage } from "./useOrderDetailsPage";
import { useParams } from "react-router-dom";

const OrderDetailsPage: React.FC = () => {
  const { id } = useParams<{ id: string }>();
  const {
    loading,
    error,
    isFullyCancelled,
    cancelledAt,
    deliveries,
    unavailableItems,
    summary,
    raw,
  } = useOrderDetailsPage(id);
  return (
    <OrderDetails
      error={error}
      loading={loading}
      isFullyCancelled={isFullyCancelled}
      cancelledAt={cancelledAt}
      deliveries={deliveries}
      unavailableItems={unavailableItems}
      summary={summary}
      raw={raw}
    />
  );
};

export default OrderDetailsPage;
